import { PlanChipType } from './plan-chip';

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface CalendarEventInterface<MetaType = any> {
  range: {
    start: Date;
    end: Date;
    startInclusive: boolean;
    endInclusive: boolean;
  };

  title: string;

  /**
   * Either a hex color code or a css variable;
   */
  color: { color: string; contrast: string };

  resizable?: {
    beforeStart?: boolean;
    afterEnd?: boolean;
  };

  /**
   * Can this item be dragged in the same day or to another day?
   */
  draggable?: boolean;

  /**
   * Can the item be dragged in the same day? Ignored when draggable is true.
   */
  reorder?: boolean;

  /**
   * Show an exclamation mark (!) on this event.
   */
  priority?: boolean;

  /**
   * Show a checkmark (✓) on this event.
   */
  finished?: boolean;

  /**
   * The id of this event. Used to link events together.
   */
  linkId?: string | number;

  /**
   * List of events this event is linked to.
   */
  linkList?: (string | number)[];

  /**
   * This would be the best place to set the content that links to this event.
   */
  meta?: MetaType;

  /**
   * ID created when the event is loaded in to the calendar, used for tracking.
   */
  trackingId?: string;

  type?: PlanChipType;
}

export enum EventListType {
  DOTS = 'dots',
  LIST = 'list',
}

export enum EventListSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
